module.exports = __webpack_public_path__ + "img/account-icon-red.9afcb52a.svg";